import store from '@/store/store'

export default (value, currency) => {
  const langMapping = {
    en: 'en-US',
    ua: 'uk-UA',
  }

  const curLang = langMapping[store.state.i18n.locale]

  return new Intl.NumberFormat(curLang || 'uk-UA', {
    style: 'currency',
    currency: currency,
  }).format(value)
}
